import React from 'react'

import {
  Box,
  Text,
  Space,
  FontWeight,
  FontFamily,
  FontSize,
  Color,
  Image,
  Display,
} from '@gousto-internal/citrus-react'

type OrderedRecipeProps = {
  name: string
  crops: { url: string; width: number }[]
  isFineDineIn: boolean
}

export const OrderedRecipe = ({ name, crops, isFineDineIn }: OrderedRecipeProps) => (
  <>
    <Box display={Display.Flex} paddingBottom={2}>
      <Box>
        <Image
          width={['60px', '80px']}
          height={['60px', '80px']}
          src={crops[0].url}
          alt={`Image of ${name}`}
        />
      </Box>
      <Space size={4} direction="horizontal" />
      <Box>
        <Text fontWeight={FontWeight.Bold} fontFamily={FontFamily.Bold} size={2}>
          {name}
        </Text>
        {isFineDineIn ? (
          <Box
            bg={Color.Informative_50}
            borderRadius={1.5}
            display={Display.InlineBlock}
            paddingV={0.5}
            paddingH={1}
          >
            <Text size={0 as FontSize} fontWeight={FontWeight.Normal}>
              Fine Dine In
            </Text>
          </Box>
        ) : null}
      </Box>
    </Box>
  </>
)
